import { Modal } from "antd"
import { LoadingRegion } from "components/custom/Loader"
import { H7 } from "components"
import React, { FC, useEffect } from "react"
import { useMutation, useQuery } from "@tanstack/react-query"
import { EMPLOYEE_ENDPOINTS, employeeService } from "services/employeeService"
import { announcementsService } from "services/announcementsService"
import parse from "html-react-parser"
import { capitalize } from "lodash"

type Props = {
  onClose: () => void
  id: string
  itemIsRead: boolean
}

export const ViewNotificationDetail: FC<Props> = ({
  onClose,
  id,
  itemIsRead,
}) => {
  const { data: detailRes, isLoading } = useQuery<
    IBaseRes<{ subject?: string; contents?: string }>
  >({
    queryKey: [EMPLOYEE_ENDPOINTS.VIEW_NOTIFICATION_DETAIL, id],
    queryFn: () => employeeService.viewNotificationDetail(id),
    refetchOnWindowFocus: false,
    cacheTime: 24 * 60 * 60 * 1000,
  })
  const data = detailRes?.data

  const { mutate: markRead } = useMutation({
    mutationFn: () => announcementsService.markRead(id),
  })

  useEffect(() => {
    if (!itemIsRead) markRead()
  }, [id, itemIsRead])

  return (
    <Modal
      onCancel={() => {
        onClose()
      }}
      footer={
        <div className="mt-5 flex justify-center gap-2">
          <div className="flex-1 flex gap-1 justify-center">
            <></>
            <></>
          </div>
        </div>
      }
      open={true}
      title={<H7 className="font-avenir ">Notification Detail</H7>}
    >
      <hr className="mb-6" />
      <div className="w-full bg-white">
        <LoadingRegion spinning={isLoading}>
          <div className="">
            <div className="font-bold text-lg font-avenir">
              {data?.subject &&
                data?.subject
                  ?.split(" ")
                  .map((it: string) => capitalize(it))
                  .join(" ")}
            </div>
            <div className="min-h-[100px] w-full">
              {data?.contents && (
                <div className="w-full font-avenir">
                  {parse(data?.contents)}
                </div>
              )}
            </div>
          </div>
        </LoadingRegion>
      </div>
    </Modal>
  )
}
